export default __webpack_public_path__ + "static/media/spark_63.eaf1b608.png";